// src/services/prescriptionCmplaintsService.js

import apiClient from "./apiClient";

const API_URL = `/prescription-complaints`; // Use relative path since apiClient has baseURL

export const getAll = async () => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(API_URL);
  return response.data;
};

export const getByPrescriptionId = async (prescriptionId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/by-prescription/${prescriptionId}`);
  return response.data;
};

export default {
  getAll,
  getByPrescriptionId
}